import { ApplicationConfig } from '@angular/core';
import { providePrimeNG } from 'primeng/config';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { MessageService, ConfirmationService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { CustomPrimeNgPreset } from './custom-primeng-preset';
import { provideAnimations } from '@angular/platform-browser/animations';
import { authInterceptor } from './auth/interceptors/auth.interceptor';
import { loadingInterceptor } from './core/interceptors/loading.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';

const ptTranslation = {
  accept: 'Sim', reject: 'Não', today: 'Hoje', clear: 'Limpar',
  dateFormat: 'dd/mm/yy',
  dayNames: ['Domingo','Segunda-feira','Terça-feira','Quarta-feira','Quinta-feira','Sexta-feira','Sábado'],
  dayNamesShort: ['Dom','Seg','Ter','Qua','Qui','Sex','Sáb'],
  dayNamesMin: ['D','S','T','Q','Q','S','S'],
  monthNames: ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'],
  monthNamesShort: ['Jan','Fev','Mar','Abr','Mai','Jun','Jul','Ago','Set','Out','Nov','Dez'],
  chooseYear: 'Ano', chooseMonth: 'Mês', chooseDate: 'Data', weekHeader: 'Sem'
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor, loadingInterceptor, errorInterceptor])),
    providePrimeNG({
      ripple: true,
      theme: {
        preset: CustomPrimeNgPreset,
        options: { darkModeSelector: '[data-theme="dark"]' }
      },
      translation: ptTranslation
    }),
    DialogService,
    MessageService,
    ConfirmationService
  ]
};
